var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconShowDuplicates = function SvgIconShowDuplicates(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.056 1c.215 0 .482.051.684.254.203.202.26.475.26.69v9.823c0 .215-.057.482-.26.684-.202.203-.47.26-.684.26h-3.4a.567.567 0 1 1 0-1.133h3.21V2.133H7.423v3.211a.567.567 0 1 1-1.133 0v-3.4c0-.215.057-.488.26-.69C6.75 1.05 7.018 1 7.233 1h9.823zm-5.29 5.289c.514 0 .945.43.945.944v9.823a.955.955 0 0 1-.944.944H1.944A.955.955 0 0 1 1 17.056V7.233c0-.513.431-.944.944-.944h9.823zm-.188 1.133H2.133v9.445h9.445V7.422z",
    fill: "#1C4566",
    fillRule: "nonzero",
    stroke: "#1C4566",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShowDuplicates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-show-duplicates.79a1569d.svg";
export { ForwardRef as ReactComponent };